export default "__VITE_ASSET__Dp$TNufD__"